import apiClient from '@/lib/api/client';
import type {
  AdminPlayerDetail,
  PlayerProfile,
  PlayerProfilePatchPayload,
  PlayersListResponse,
  PlayerStatus,
  PlayerStatusUpdatePayload,
} from '@/types/player.types';

export const playerService = {
  async getProfile(): Promise<PlayerProfile> {
    const response = await apiClient.get<PlayerProfile>('/settings/player');
    return response.data;
  },

  async updateProfile(payload: PlayerProfilePatchPayload): Promise<PlayerProfile> {
    const response = await apiClient.patch<PlayerProfile>('/settings/player', payload);
    return response.data;
  },

  async getAdminPlayers(params?: {
    search?: string;
    page?: number;
    limit?: number;
    status?: PlayerStatus;
  }): Promise<PlayersListResponse> {
    const response = await apiClient.get<PlayersListResponse>('/individual-players', { params });
    return response.data;
  },

  async getAdminPlayerById(id: string): Promise<AdminPlayerDetail> {
    const response = await apiClient.get<AdminPlayerDetail>(`/individual-players/${id}`);
    return response.data;
  },

  async updatePlayerStatus(id: string, payload: PlayerStatusUpdatePayload): Promise<void> {
    await apiClient.patch(`/individual-players/${id}/status`, payload);
  },
};
